module.exports = __webpack_public_path__ + "static/media/16.bb2aa4c9.jpeg";